import Icon from '../components/atoms/Icon';

const socialChannels = [
  'twitter',
  'facebook',
  'xing',
  'linkedin',
  'youtube',
  'instagram',
  'blog',
  'content-hub',
];

/**
 * @param {SocialMediaChannel} channel
 * @param {string | undefined} [color]
 * @returns {React.ReactElement} The rendered component
 */
const getSocialChannel = (channel, color) => {
  const { url } = channel;
  const text = channel.text ?? channel.url;

  let channelName = 'DEFAULTCHANNEL';
  socialChannels.map((item) => {
    if (url.indexOf(item) !== -1) {
      if (item === 'content-hub') {
        channelName = 'blog';
      } else {
        channelName = item;
      }
    }
    return false;
  });

  return (
    <a
      key={channelName}
      href={url}
      title={text}
      rel="noreferrer noopener"
      target="_blank"
    >
      <Icon icon={channelName.toLocaleUpperCase()} color={color} />
    </a>
  );
};

export default getSocialChannel;
